import { render, staticRenderFns } from "./SidebarEditor.vue?vue&type=template&id=73e449bf&scoped=true&"
import script from "./SidebarEditor.vue?vue&type=script&lang=js&"
export * from "./SidebarEditor.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditor.vue?vue&type=style&index=0&id=73e449bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e449bf",
  null
  
)

export default component.exports